export enum TrackingSource {
  production = 'crm2-event-production',
  testing = 'crm2-event-testing',
  log = 'crm2-log',
  ux = 'crm2-ux',
}
